import _ from 'lodash'
import { Select, Option } from '../select'

export default {
  name: 'KPaginationSizeChanger',
  inject: ['context'],
  data() {
    return {}
  },
  computed: {
    pageSize: {
      get() {
        return this.context.innerPageSize
      },
      set(value) {
        this.context.innerPageSize = value
      },
    },
    pageSizeOptions() {
      return this.context.pageSizeOptions
    },
    disabled() {
      return this.context.disabled
    },
    small() {
      return this.context.small
    },
  },
  watch: {},
  methods: {
    handlePageSizeChange(value) {
      this.pageSize = value
    },
  },
  render() {
    return (
      <Select
        size={this.small ? 'small' : null}
        class="km-pagination__size-changer"
        value={this.pageSize}
        disabled={this.disabled}
        onInput={this.handlePageSizeChange}
      >
        {
          _.map(this.pageSizeOptions, option => (
            <Option
              label={`每页 ${option} 条`}
              value={+option}
              showCheckIcon={false}
            >
            </Option>
          ))
        }
      </Select>
    )
  },
}
